module.exports = __webpack_public_path__ + "img/Logo_SonagiBlue-02.9931c88a.svg";